<template>
  <div class="nearby-stop">
    <router-link
      :to="{
                name: 'stopinfo',
                params: {
                    id: stopId,
                }
            }"
      class="nearby-stop-a"
    >
      <div class="stopc">
        {{ stopName }}
      </div>

      <div class="routes">
        <div
          v-for="(route, index) in routes"
          :key="index"
          class="stop-route"
        >
          <div class="routec">
            {{ route.routec }}
          </div>
          <div class="destinc">
            {{ route.routedir === 1 ? route.destinc : route.startc }}
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NearbyStop",
  props: [
    "stop",
  ],
  computed: {
    stopName() {
      return this.stop.routes[0].stopc;
    },
    stopId() {
      return this.stop.routes[0].stopid;
    },
    routes() {
      if (this.stop.routes.length >= 2) {
        return [
          this.stop.routes[0],
          this.stop.routes[1]
        ];
      } else if (this.stop.routes.length === 1) {
        return [
          this.stop.routes[0],
        ];
      } else {
        return [];
      }
    },
  }
}
</script>

<style scoped>
.nearby-stop-a {
  display: flex
}

.stopc, .routes, .routec, .destinc {
  display: inline-block;
  vertical-align: top;
}

.stopc {
  flex: 0 0 120px;
  line-height: 24px;
  /*width: 100px;*/
}

.routes {
  flex: 1 0 200px;
}

.stop-route {
  display: flex
}

.routec {
  flex: 0 0 55px;
}

.destinc {
  flex: 1 0 100px;
}

</style>
